module.exports = "../images/cabin-6-person-3@2x.jpg?v=38de469";